import { electron } from 'lib-shared-electron';
import { compareSemVer } from 'lib-shared-semver';

/**
 * Compare two versions of releases to see if the version is below the specified
 * version
 *
 * @param desktopAppNoticeCache The version that's being compared to
 */
export async function isDesktopAppVersionBelow(
  version: string,
): Promise<boolean> {
  const desktopAppVersion = await electron.getVersion();
  return compareSemVer(desktopAppVersion, version) === -1;
}
